module.exports = __webpack_public_path__ + "static/media/menu_grey.82515d76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar/icons/menu_grey.svg
// module id = 1672
// module chunks = 0